import { ICON__chart_diagram_solid } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { use_slice_generation, use_slice_ui } from '@/hooks/store/use_slices';
import { PLACEHOLDER_BUTTON__bar_10_5 } from '@/pages/_base/buttons/PLACEHOLDER_BUTTON__bar_10_5';
import { UTILS__graph_data } from '@/utils/UTILS__graph_data';
import { FN_GRAPH__layout_create } from '@shared/dto/generation/graph_invoke/_templates/_methods/FN_GRAPH__layout_create';

export function G_BUTTON__graph_autolayout() {
  /*
   * STORE
   */

  const { generation_current } = use_slice_generation(['generation_current']);
  const { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);

  /*
   * EVENTS
   */
  async function onClick() {
    let graph_new = generation_current.tool.graph.clone();

    FN_GRAPH__layout_create(graph_new);

    await UTILS__graph_data.update(graph_new);
  }
  /*
   * METHODS
   */

  function is_disabled() {
    return g_general__ui_disabled;
  }

  /*
   * HTML
   */

  if (generation_current.is_stub()) return <PLACEHOLDER_BUTTON__bar_10_5 />;
  if (generation_current.tool.graph.nodes_map.size() < 2) return <PLACEHOLDER_BUTTON__bar_10_5 />;

  return (
    <UI_PRIMITIVE__button size="rect-10-6" variant={'no-border-on-component'} disabled={is_disabled()} {...{ onClick }}>
      <ICON__chart_diagram_solid className="size-3" />
    </UI_PRIMITIVE__button>
  );
}
